import { TransparentCard, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { MagnifierIcon, WalletIcon, ChartIcon } from "./Icons";
import { Link } from "react-router-dom";

interface ServiceProps {
  title: string;
  description: string;
  icon: JSX.Element;
}

const serviceList: ServiceProps[] = [
  {
    title: "Monitor Every Exchange",
    description:
      "Monitor your entire portfolio and execute orders through a single interface.",
    icon: <WalletIcon />,
  },
  {
    title: "Unparalleled Tools",
    description:
      "Customize charts, hotkeys, and indicators. Run trading algorithms. Utilize the most advanced depth of book on the market.",
    icon: <ChartIcon />,
  },
  {
    title: "Live Support",
    description:
      "No bots or outsourced agents. Get assistance via phone, email, or on Discord.",
    icon: <MagnifierIcon />,
  },
];

export const Services = () => {
  return (
  <section 
    id="services"
    className="container py-24 sm:py-32">
    <div className="gap-8 place-items-center justify-center items-center">
      <div className="w-full flex flex-col items-center text-center"> {/* Added classes here */}
        <h2 className="text-3xl md:text-4xl font-bold">
          <span className="bg-gradient-to-b from-primary/60 to-primary text-transparent bg-clip-text">
            Professional{" "}
          </span>
          Trading Tools
        </h2>

        <p className="text-muted-foreground text-xl mt-4 mb-8 ">
          Tailor-made for investors, traders and quants.
        </p>

        <div className="flex flex-row flex-wrap gap-8 w-full items-stretch justify-center">
          {serviceList.map(({ icon, title, description }: ServiceProps) => (
            <TransparentCard key={title} className="w-full flex-1 min-w-[260px] mx-auto">
              <CardHeader className="flex flex-col items-center text-center gap-2">
                <div className="mt-1 bg-primary/20 p-1 rounded-2xl flex items-center justify-center">
                  {icon}
                </div>
                <CardTitle className="mt-2">{title}</CardTitle>
                <CardDescription className="text-md mt-2">
                  {description}
                </CardDescription>
              </CardHeader>
            </TransparentCard>
          ))}
        </div>

        <div className="w-full bg-muted/10 rounded-lg p-4 text-center">
            <video 
            controls
            autoPlay 
            loop 
            muted 
            playsInline
            className="w-full mx-auto"
            >
                <source src="/App-Demo-Algo-Interact.webm" type="video/webm" />
                Your browser does not support the video tag.
            </video>
        </div>
        
        <div className="mt-4">
          And so much more. <Link to="roadmap" className="text-primary hover:underline font-semibold">Visit our Roadmap</Link> for everything that is <span className="text-primary">Doyen Trading.</span>
        </div>
      </div>
    </div>
  </section>
  );
};
